import { render, staticRenderFns } from "./EditIconNew.vue?vue&type=template&id=7f4ced88"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4ced88')) {
      api.createRecord('7f4ced88', component.options)
    } else {
      api.reload('7f4ced88', component.options)
    }
    module.hot.accept("./EditIconNew.vue?vue&type=template&id=7f4ced88", function () {
      api.rerender('7f4ced88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/EditIconNew.vue"
export default component.exports